import { TrendingUp, Calculator, FileText, Users } from 'lucide-react';

const Services = () => {
  const services = [
    {
      title: 'Financial Services',
      icon: TrendingUp,
      description: 'Comprehensive financial planning, analysis, and strategic advisory to optimize your business performance and growth.',
      image: 'https://customer-assets.emergentagent.com/job_6ea43fd1-5285-4529-ac47-50204ab809b3/artifacts/dhsx10y5_oqddwsmj_shutterstock_519476584-r.jpg',
    },
    {
      title: 'Accounting Services',
      icon: Calculator,
      description: 'Professional bookkeeping, financial reporting, and accounting management tailored to your business requirements.',
      image: 'https://customer-assets.emergentagent.com/job_6ea43fd1-5285-4529-ac47-50204ab809b3/artifacts/ijrj3byg_pq4gfw0m_shutterstock_758307391-r.jpg',
    },
    {
      title: 'Tax & Legal Consulting',
      icon: FileText,
      description: 'Expert tax planning, compliance, and legal consulting services to ensure regulatory adherence and minimize liabilities.',
      image: 'https://customer-assets.emergentagent.com/job_6ea43fd1-5285-4529-ac47-50204ab809b3/artifacts/pgpwnk4t_p9ho3u92_shutterstock_613671434-r.jpg',
    },
    {
      title: 'Managerial Services',
      icon: Users,
      description: 'Strategic management consulting to enhance operational efficiency and drive sustainable business growth.',
      image: 'https://customer-assets.emergentagent.com/job_6ea43fd1-5285-4529-ac47-50204ab809b3/artifacts/no29wqca_171ynlsx_shutterstock_431851042-r.jpg',
    },
  ];

  return (
    <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full" style={{backgroundImage: 'radial-gradient(circle, #1e3a8a 1px, transparent 1px)', backgroundSize: '50px 50px'}}></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-blue-900 mb-4">
            OUR SERVICES
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Comprehensive financial and consulting solutions for your business success
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="group relative bg-white rounded-xl border border-gray-200 overflow-hidden hover:border-blue-300 transition-all duration-300 hover:shadow-2xl transform hover:-translate-y-2"
              >
                {/* Image Section */}
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 bg-white w-14 h-14 rounded-lg flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <Icon className="text-blue-900" size={28} />
                  </div>
                </div>

                {/* Content Section */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-blue-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;